import { EListingOffersActionType, TAddOffersPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const addOffers = actionGenerator<EListingOffersActionType.AddOffers, TAddOffersPayload>(
  EListingOffersActionType.AddOffers,
);
